import {
  faCalendarAlt,
  faUser,
  faBuilding,
  faBoxOpen,
  faTools,
  faCheckCircle,
  faFolder,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import createField from "../../utils/factory/createField";

export const movementFields = [
  {
    section: "Informações do Movimento",
    fields: [
      createField({
        id: "movement.movement_date",
        label: "Data",
        type: "date",
        icon: faCalendarAlt,
      }),
      createField({
        id: "movement.service_order_id",
        label: "Requisição",
        type: "multi-select",
        placeholder: "Selecione a Requisição",
        entity: "serviceOrder",
        column: "id",
        columnLabel: "id",
        columnDetails: null,
        icon: faTools,
      }),
      createField({
        id: "movement.recipient_customer_id",
        label: "Destinatário",
        type: "multi-select",
        placeholder: "Selecione o cliente destinatário",
        entity: "customer",
        column: "id",
        columnLabel: "id",
        columnDetails: "name",
        icon: faUser,
      }),
      createField({
        id: "movement.organization_id",
        label: "Organização",
        type: "multi-select",
        placeholder: "Selecione a organização",
        entity: "organization",
        column: "id",
        columnLabel: "name",
        columnDetails: null,
        icon: faBuilding,
      }),
    ],
  },
  {
    section: "Insumos",
    array: true,
    count: 0,
    fields: [
      createField({
        id: "items.movement_type_id",
        label: "Tipo Movimento",
        type: "multi-select",
        placeholder: "Selecione o Tipo de Movimento",
        entity: "movementType",
        column: "id",
        columnLabel: "name",
        icon: faTools,
      }),
      createField({
        id: "items.service_order_item_id",
        label: "Item Requisição",
        type: "multi-select",
        placeholder: "Selecione o Item da Requisição",
        icon: faTools,
      }),
      createField({
        id: "items.product_id",
        label: "Insumo",
        type: "multi-select",
        placeholder: "Selecione o Insumo",
        entity: "product",
        column: "name",
        isUnique: true,
        columnLabel: "number",
        columnDetails: "name",
        icon: faBoxOpen,
      }),
      createField({
        id: "items.item_id",
        label: "Número Item",
        type: "text",
        placeholder: "Digite o identificador do item",
        icon: faBoxOpen,
      }),
      createField({
        id: "items.old_organization_id",
        label: "Organização Antiga",
        type: "multi-select",
        placeholder: "Selecione a Organização Antiga",
        entity: "organization",
        column: "id",
        columnLabel: "name",
        columnDetails: null,
        notRequired: true,
        icon: faBuilding,
      }),
      createField({
        id: "items.new_organization_id",
        label: "Organização Nova",
        type: "multi-select",
        placeholder: "Selecione a Organização Nova",
        entity: "organization",
        column: "id",
        columnLabel: "name",
        columnDetails: null,
        notRequired: true,
        icon: faBuilding,
      }),
    ],
  },
];

export const editMovementsFields = [
  {
    section: "Informações do Movimento",
    fields: [
      createField({
        id: "movement_date",
        label: "Data",
        type: "date",
        fullWidth: true,
        icon: faCalendarAlt,
      }),
    ],
  },
];

export const detailsMovementFields = [
  {
    section: "Informações",
    fields: [
      createField({
        id: "number",
        label: "Nº Protocolo",
        type: "text",
        icon: faCalendarAlt,
        disabled: true,
      }),
      createField({
        id: "movement_type",
        label: "Tipo Movimento",
        type: "text",
        icon: faTools,
        disabled: true,
      }),
      createField({
        id: "service_order_id",
        label: "Nº Requisição",
        type: "text",
        icon: faTools,
        disabled: true,
      }),
      createField({
        id: "user_name",
        label: "Criado Por",
        type: "text",
        icon: faUser,
        disabled: true,
      }),
      createField({
        id: "recipient_customer",
        label: "Cliente Destinatário",
        type: "text",
        icon: faUser,
        disabled: true,
      }),
      createField({
        id: "destination",
        label: "Destino",
        type: "text",
        icon: faBuilding,
        disabled: true,
      }),
      createField({
        id: "created_at",
        label: "Criado Em",
        type: "text",
        icon: faCalendarAlt,
        fullWidth: true,
        disabled: true,
      }),
    ],
  },
];

export const detailsMaintenanceMovementFields = [
  {
    section: "Informações do Movimento",
    fields: [
      createField({
        id: "movement_date",
        label: "Data",
        type: "text",
        icon: faCalendarAlt,
        disabled: true,
      }),
      createField({
        id: "status_id",
        label: "Status",
        type: "text",
        icon: faCheckCircle,
        disabled: true,
      }),
      createField({
        id: "recipient_customer_id",
        label: "Destinatário",
        type: "text",
        icon: faUser,
        disabled: true,
      }),
      createField({
        id: "organization_id",
        label: "Organização",
        type: "text",
        icon: faBuilding,
        disabled: true,
      }),
    ],
  },
];

export const baseMovementFields = [
  {
    section: "Informações do Movimento",
    fields: [
      createField({
        id: "movement.movement_date",
        label: "Data",
        type: "date",
        icon: faCalendarAlt,
      }),
      createField({
        id: "movement.service_order_id",
        label: "Requisição",
        type: "select",
        placeholder: "Selecione a Requisição",
        icon: faTools,
      }),
      createField({
        id: "movement.recipient_customer_id",
        label: "Cliente Destinatário",
        type: "select",
        placeholder: "Selecione o cliente destinatário",
        icon: faUser,
        fullWidth: true,
        disabled: true,
      }),
      // 🆕 Par 1: Tipo de Movimento | Prazo Final
      createField({
        id: "info.movement_type",
        label: "Tipo de Movimento",
        type: "text",
        icon: faTools,
        disabled: true,
      }),
      createField({
        id: "info.deadline",
        label: "Prazo Final",
        type: "text",
        icon: faCalendarAlt,
        disabled: true,
      }),
      // 🆕 Linhas completas
      createField({
        id: "info.contract",
        label: "Contrato",
        type: "text",
        icon: faFolder,
        disabled: true,
        fullWidth: true,
      }),
      createField({
        id: "info.destination",
        label: "Destino",
        type: "text",
        icon: faMapMarkerAlt,
        disabled: true,
        fullWidth: true,
      }),
      createField({
        id: "info.address",
        label: "Endereço do Destino",
        type: "text",
        icon: faMapMarkerAlt,
        disabled: true,
        fullWidth: true,
      }),
    ],
  },
];

export const dynamicFields = {
  1: {
    section: "Insumos",
    view: "fields",
    count: 0,
    fields: [
      createField({
        id: "items.service_order_item_id",
        label: "Item Requisição",
        type: "multi-select",
        placeholder: "Selecione o Item da Requisição",
        disabled: true,
        icon: faTools,
      }),
      createField({
        id: "items.movement_type_id",
        label: "Tipo Movimento",
        type: "multi-select",
        placeholder: "Selecione o Tipo de Movimento",
        entity: "movementType",
        column: "name",
        columnLabel: "name",
        icon: faTools,
        disabled: true,
      }),
      createField({
        id: "items.contract_item_id",
        label: "Item Contrato",
        type: "text",
        placeholder: "Digite o Identificador do item do contrato",
        icon: faBoxOpen,
        disabled: true,
      }),
      createField({
        id: "items.product_id",
        label: "Insumo",
        type: "multi-select",
        placeholder: "Selecione o Insumo",
        entity: "product",
        column: "number",
        isUnique: true,
        columnLabel: "number",
        columnDetails: "name",
        icon: faBoxOpen,
      }),
    ],
  },
  2: {
    section: "Insumos",
    view: "fields",
    count: 0,
    fields: [
      createField({
        id: "items.service_order_item_id",
        label: "Item Requisição",
        type: "multi-select",
        placeholder: "Selecione o Item da Requisição",
        disabled: true,
        icon: faTools,
      }),
      createField({
        id: "items.movement_type_id",
        label: "Tipo Movimento",
        type: "multi-select",
        placeholder: "Selecione o Tipo de Movimento",
        entity: "movementType",
        column: "name",
        columnLabel: "name",
        icon: faTools,
        disabled: true,
      }),
      createField({
        id: "items.product_id",
        label: "Insumo",
        type: "multi-select",
        placeholder: "Selecione o Insumo",
        entity: "product",
        column: "number",
        isUnique: true,
        columnLabel: "number",
        columnDetails: "name",
        icon: faBoxOpen,
        disabled: true,
      }),
      createField({
        id: "items.new_product_id",
        label: "Novo Insumo",
        type: "multi-select",
        placeholder: "Selecione o Novo Insumo",
        entity: "product",
        column: "number",
        isUnique: true,
        columnLabel: "number",
        columnDetails: "name",
        icon: faBoxOpen,
      }),
    ],
  },
  3: {
    section: "Insumos",
    view: "fields",
    count: 0,
    fields: [
      createField({
        id: "items.service_order_item_id",
        label: "Item Requisição",
        type: "multi-select",
        placeholder: "Selecione o Item da Requisição",
        disabled: true,
        icon: faTools,
      }),
      createField({
        id: "items.movement_type_id",
        label: "Tipo Movimento",
        type: "multi-select",
        placeholder: "Selecione o Tipo de Movimento",
        entity: "movementType",
        column: "name",
        columnLabel: "name",
        icon: faTools,
        disabled: true,
      }),
      createField({
        id: "items.product_id",
        label: "Insumo",
        type: "multi-select",
        placeholder: "Selecione o Insumo",
        entity: "product",
        column: "number",
        isUnique: true,
        columnLabel: "number",
        columnDetails: "name",
        icon: faBoxOpen,
        disabled: true,
      }),
    ],
  },
};